import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "./tailwind/button";
import { UIMatch, useMatches } from "react-router-dom";

export interface TitleProps {
  files: [
    {
      id: number;
      title: string;
      comment: string;
    }
  ];
  onEdit: () => void;
  onChange?: (value: string) => void;
  title?: string;
  comment?: string;
}

export type CustomHandle = {
  title?: string;
};

export default function Title({
  files,
  onChange,
  onEdit,
  title,
  comment,
}: TitleProps) {
  const getFileTitle = ({
    title,
    comment,
  }: {
    title: string;
    comment: string;
  }) => comment || title;

  const matches = useMatches();
  const typedMatches = matches as UIMatch<unknown, CustomHandle>[];
  const currentMatch = typedMatches[typedMatches.length - 1];
  const pageTitle = currentMatch?.handle?.title;
  return (
    <h1 className="text-dark-m3 pb-0 mb-1 text-130">
      <div className={files.length === 1 ? "" : "btn-group"}>
        <span className="d-lg-inline">{pageTitle}</span>
        {files.length === 1 ? (
          <small> {getFileTitle(files[0])}</small>
        ) : (
          <div className="dropdown dd-backdrop dd-backdrop-none-md ml-3">
            <select
              className="btn btn-sm btn-light-secondry"
              onChange={(e) => onChange && onChange(e.target.value)}
            >
              <option selected disabled hidden>
                {title ? title : "انتخاب کنید..."}
              </option>
              {files &&
                files.map((file) => (
                  <option key={file.id} value={file.id}>
                    {getFileTitle(file)}
                  </option>
                ))}
            </select>
          </div>
        )}
        {title && (
          <Button className="btn-light-secondry" onClick={onEdit}>
            <FontAwesomeIcon icon="pen" />
          </Button>
        )}
      </div>
    </h1>
  );
}
